import {
  game,
  THREE
} from '@powerplay/core-minigames'
import { player } from '../athlete/player'
import { Skybox } from './Skybox'

/**
 * Trieda pre prostredie
 */
export class WorldEnv {

  /** Priehladna stena v cieli */
  private finishWall!: THREE.Mesh

  /** obloha */
  public skybox = new Skybox()

  /**
   * Vytvorenie prostredia
   */
  public create(): void {

    console.log('VYTVARAM ENV....')

    game.getMesh('TrackCycling_Mesh001_3').renderOrder = 2
    this.finishWall = game.getMesh('finish_TrackCycling_Finish')
    this.setVisibilityFinishWall(false)
    this.skybox.create()

    console.log('ENV vytvoreny....')

  }

  /**
   * Nastavenie viditelnosti steny v cieli
   * @param visibility - Viditelnost
   */
  public setVisibilityFinishWall(visibility: boolean): void {

    this.finishWall.visible = visibility

  }

  /**
   * Nastavenie tienov
   */
  public setUpShadows(): void {

    game.shadowsManager.setObjectToFollowWithLight(player.athleteObject)
    this.setMeshAsShadowPlane('TrackCycling_Mesh001_12')
    this.setMeshAsShadowPlane('TrackCycling_Mesh001_7')

  }

  /**
   * Nastavenie meshu ako shadow plane
   * @param meshName - nazov meshu
   */
  public setMeshAsShadowPlane(meshName: string): void {

    const mesh = game.getMesh(meshName).clone()
    mesh.name += 'cloned'
    game.scene.add(mesh)
    game.shadowsManager.setTerrainShadowPlane(mesh)

  }

  /**
   * Aktualizovanie veci spolu s animaciami, teda na FULL FPS
   * @param elapsedTime - Kolko casu uplynulo, kvoli shaderom
   */
  public updateWithAnimations(elapsedTime: number): void {

    this.skybox.update(elapsedTime)

  }

  /**
   * Aktualizovanie veci v normalnom internom FPS
   */
  public update(): void {

    // momentalne nic

  }

}

export const worldEnv = new WorldEnv()
